import { dialog, InputJson, toDisplayCase } from "nq-component";
import {
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../withRouter";
import BaseFormPage from "../../../../../base/BaseFormPage";
import NavBar from "../../../../../components/navbar";
import DialogModal from "../../../../../components/Dialog";
import InventoryFormPresenter from "./InventoryFormPresenter";
import InventoryTable, { QuantityBulkInput } from "./components/InventoryTable";

class InventoryFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      raw: null,
      advanced: false,
      selectedRawIds: [],
      infiniteItems: [],
      skip: 0,
      hasMore: true,
      isLoading: false,
      selectedQuantities: {},
      inputQuantity: "",
      searchKeyword: "",
    };

    this.presenter = new InventoryFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "inventory";
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }
  async fetchInfiniteItems(isInitial = false) {
    this.presenter.fetchInfiniteItems((isInitial = false));
  }

  handleInfiniteScroll = (e) => {
    this.presenter.handleInfiniteScroll(e);
  };

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onSubmitForm(e) {
    e.preventDefault();

    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm to Proceed"
          message="Are you sure want to continue this action?"
          isCancelButton={true}
          onSubmit={() => this.presenter.submit()}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onChange(value, field) {
    if (field === "quantity") {
      const hasValue = value !== undefined && value !== null && value !== "";
      this.setState({ hasQuantity: hasValue });
    }

    this.presenter.onChange(value, field);
  }

  handleSelectAll = (e) => {
    const checked = e.target.checked;
    const allIds = this.state.infiniteItems.map((item) => item.id);

    this.setState({
      selectedRawIds: checked ? allIds : [],
    });
  };

  handleSelectOne = (e, id) => {
    const { selectedRawIds } = this.state;
    const updated = e.target.checked
      ? [...selectedRawIds, id]
      : selectedRawIds.filter((itemId) => itemId !== id);

    this.setState({ selectedRawIds: updated });
  };

  applyBulkQuantityUpdate = () => {
    const quantity = this.state.inputQuantity.trim();
    if (!quantity) return;

    const { selectedRawIds, infiniteItems, selectedQuantities, object } =
      this.state;

    const updatedQuantities = { ...selectedQuantities };
    const updatedRawMap = new Map(
      (object.raw_materials || []).map((item) => [item.id, item])
    );

    selectedRawIds.forEach((id) => {
      const item = infiniteItems.find((itm) => itm.id === id);
      if (item) {
        const updatedItem = { ...item, quantity };

        updatedQuantities[id] = updatedItem;
        updatedRawMap.set(id, updatedItem);
      }
    });

    this.setState({
      selectedQuantities: updatedQuantities,
      object: {
        ...object,
        raw_materials: Array.from(updatedRawMap.values()),
      },
      inputQuantity: "",
      selectedRawIds: [],
    });
  };

  handleSearchChange = async (keyword) => {
    this.setState({ searchKeyword: keyword });
    await this.presenter.fetchInfiniteItems(true, keyword);
  };

  getAdjustmentType() {
    const search = this.props.location?.search || "";
    const params = new URLSearchParams(search);
    return params.get("type");
  }

  render() {
    const { object } = this.state;
    const adjustmentType = this.getAdjustmentType();
    const advanced = this.state.advanced;
    console.log("this.state.infiniteItems", this.state.infiniteItems);
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Edit ";
    return (
      <>
        <NavBar />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h2
                className="fw-bold mt-3 text-capitalize"
                style={{ color: "#82c14a" }}
              >
                <i
                  onClick={() => this.navigateBack()}
                  class="bi bi-chevron-compact-left"
                  style={{ color: "black" }}
                ></i>
                {label +
                  (schema.label ||
                    toDisplayCase(this.getCollectionName()))}{" "}
                : <span className="text-dark">{adjustmentType}</span>
              </h2>
              <div
                className="mt-2 shadow rounded p-3 px-lg-5 py-lg-4"
                style={{ backgroundColor: "#f6f5fa" }}
              >
                <h6>Details</h6>
                <hr />
                <form onSubmit={this.onSubmitForm.bind(this)}>
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChange.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <QuantityBulkInput
                        quantity={this.state.inputQuantity}
                        isDisabled={this.state.selectedRawIds.length === 0}
                        onChange={(e) =>
                          this.setState({ inputQuantity: e.target.value })
                        }
                        onUpdate={this.applyBulkQuantityUpdate}
                      />
                    )}
                  </div>
                  {/* <InventoryTable
                    title="Raw Materials Breakdown"
                    items={this.state.infiniteItems}
                    selectedIds={this.state.selectedRawIds}
                    selectedQuantities={this.state.selectedQuantities}
                    isLoading={this.state.isLoading}
                    onSelectAll={this.handleSelectAll}
                    onSelectOne={this.handleSelectOne}
                    onQuantityChange={(e, item) => {
                      const qty = e.target.value;
                      this.setState((prev) => ({
                        selectedQuantities: {
                          ...prev.selectedQuantities,
                          [item.id]: {
                            ...item,
                            quantity: qty,
                          },
                        },
                      }));
                    }}
                    onScroll={this.handleInfiniteScroll}
                  /> */}

                  <InventoryTable
                    title="Raw Materials Breakdown"
                    items={this.state.infiniteItems}
                    selectedIds={this.state.selectedRawIds}
                    selectedQuantities={this.state.selectedQuantities}
                    isLoading={this.state.isLoading}
                    searchKeyword={this.state.searchKeyword}
                    onSearchChange={this.handleSearchChange}
                    onSelectAll={this.handleSelectAll}
                    onSelectOne={this.handleSelectOne}
                    onQuantityChange={(e, item) => {
                      const qty = e.target.value;
                      this.setState((prev) => ({
                        selectedQuantities: {
                          ...prev.selectedQuantities,
                          [item.id]: {
                            ...item,
                            quantity: qty,
                          },
                        },
                      }));
                    }}
                    onScroll={this.handleInfiniteScroll}
                  />

                  <div className="mt-4 text-center">
                    <button
                      type="button"
                      className="btn fs-sm "
                      onClick={this.onClickBack.bind(this)}
                      style={{ backgroundColor: "#d1d1d1" }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn fs-sm text-white ms-3"
                      style={{ backgroundColor: "#82c14a" }}
                    >
                      <i className="bi text-white bi-file-earmark-check me-2"></i>
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(InventoryFormPage);
